// ─── TEMAS ────────────────────────────────────────────────────────────────────
import { Menu, Sun, Moon } from "lucide-react";

export const DARK_THEME_ORCAMENTO = {
  crimson:      "#C8003E",
  amber:        "#F5A623",
  darkBg:       "#000000",
  cardBg:       "#1A1D24",
  border:       "#2A2D35",
  text:         "#FFFFFF",
  muted:        "#8B90A0",
  danger:       "#EF4444",
  success:      "#22C55E",
  indigo:       "#6366F1",
  // Superfícies adicionais (antes hardcoded)
  panelBg:      "#0D0F14",
  rowAlt:       "#14161C",
  rowAlt88:     "#14161C88",
  subBg:        "#1C1F28",
  deepBg:       "#0F1118",
  deepBg2:      "#0A0C12",
  drawerBg:     "#13151C",
  tooltipBg:    "#1E2128",
  hover:        "#2A2D35",
  inputDisabled:"#111318",
  headerGradient: "linear-gradient(to right, #581c87, #9d174d)",
  headerText:   "#e9d5ff",
  scrollThumb:  "#2A2D35",
  card:         "#000000"
};

export const LIGHT_THEME_ORCAMENTO = {
  crimson:      "#B0003A",
  amber:        "#C47A00",
  darkBg:       "#F0F2F8",
  cardBg:       "#FFFFFF",
  border:       "#DDE1EC",
  text:         "#7e8186ff",
  muted:        "#6B7280",
  danger:       "#DC2626",
  success:      "#16A34A",
  indigo:       "#4F46E5",
  // Superfícies adicionais
  panelBg:      "#F5F7FD",
  rowAlt:       "#F0F2FA",
  rowAlt88:     "#EEF0F8",
  subBg:        "#E8EBF6",
  deepBg:       "#EDF0FA",
  deepBg2:      "#E5E9F5",
  drawerBg:     "#FFFFFF",
  tooltipBg:    "#FFFFFF",
  hover:        "#E4E7F2",
  inputDisabled:"#F3F4F9",
  headerGradient: "linear-gradient(to right, #4c1d95, #831843)",
  headerText:   "#ddd6fe",
  scrollThumb:  "#CBD5E1",
  card:          "#FFFFFF"
};


export const DARK_THEME_PAINEL_EXECUTIVO = {
  brand:      "#C0003C",
  brandDark:  "#8B0029",
  brandMid:   "#E0004A",
  accent:     "#FF3368",
  bg:         "#0D0F14",
  surface:    "#13161E",
  card:       "#181C26",
  border:     "#242836",
  text:       "#E8EAF0",
  muted:      "#6B7280",
  pos:        "#00D084",
  neg:        "#FF3D6A",
  line1:      "#C0003C",
  line2:      "#FF8C42",
  tooltipBg:  "#1E2232",
  inputBg:    "#1e131eff",
  headerText: "#e9d5ff",
  headerGradient: "linear-gradient(to right, #581c87, #9d174d)",
  shadow:     "0 8px 32px rgba(0,0,0,0.5)",
  shadowCard: "0 16px 48px rgba(0,0,0,0.7)",
  dateFilter: "invert(1)",
  selectBg:   "#13161E",
  selectBorder: "rgba(255,255,255,0.25)",
};

export const LIGHT_THEME_PAINEL_EXECUTIVO = {
  brand:      "#B0003A",
  brandDark:  "#7A0028",
  brandMid:   "#CC0044",
  accent:     "#E8205A",
  bg:         "#F0F2F8",
  surface:    "#E8EBF5",
  card:       "#FFFFFF",
  border:     "#DDE1EC",
  text:       "#111827",
  muted:      "#6B7280",
  pos:        "#16A34A",
  neg:        "#DC2626",
  line1:      "#B0003A",
  line2:      "#D97706",
  tooltipBg:  "#FFFFFF",
  inputBg:    "#F5F7FD",
  headerText: "#ddd6fe",
  headerGradient: "linear-gradient(to right, #4c1d95, #831843)",
  shadow:     "0 8px 32px rgba(0,0,0,0.12)",
  shadowCard: "0 16px 48px rgba(0,0,0,0.15)",
  dateFilter: "none",
  selectBg:   "rgba(0,0,0,0.18)",
  selectBorder: "rgba(255,255,255,0.35)",
};

export const C = {
  crimson: "#C8003E", amber: "#F5A623", darkBg: "#000000ff",
  cardBg: "#1A1D24", border: "#2A2D35", text: "#FFFFFF",
  muted: "#8B90A0", danger: "#EF4444", success: "#22C55E", indigo: "#6366F1",
};


export const DARK_THEME_PAG_REC = {
  brand:           "#C0003C",
  brandDark:       "#8B0029",
  brandMid:        "#E0004A",
  accent:          "#FF3368",
  bg:              "#0D0F14",
  surface:         "#13161E",
  card:            "#181C26",
  border:          "#242836",
  text:            "#E8EAF0",
  muted:           "#6B7280",
  pos:             "#00D084",
  neg:             "#FF3D6A",
  line1:           "#C0003C",
  line2:           "#FF8C42",
  tooltipBg:       "#1E2232",
  inputBg:         "#13161E",
  headerText:      "#e9d5ff",
  headerGradient:  "linear-gradient(to right, #581c87, #9d174d)",
  shadow:          "0 8px 32px rgba(0,0,0,0.5)",
  shadowCard:      "0 16px 48px rgba(0,0,0,0.7)",
  dateFilter:      "invert(1)",
  selectBg:        "rgba(0,0,0,0.25)",
  selectBorder:    "rgba(255,255,255,0.25)",
};

export const LIGHT_THEME_PAG_REC = {
  brand:           "#B0003A",
  brandDark:       "#7A0028",
  brandMid:        "#CC0044",
  accent:          "#E8205A",
  bg:              "#F0F2F8",
  surface:         "#E8EBF5",
  card:            "#FFFFFF",
  border:          "#DDE1EC",
  text:            "#111827",
  muted:           "#6B7280",
  pos:             "#16A34A",
  neg:             "#DC2626",
  line1:           "#B0003A",
  line2:           "#D97706",
  tooltipBg:       "#FFFFFF",
  inputBg:         "#F5F7FD",
  headerText:      "#ddd6fe",
  headerGradient:  "linear-gradient(to right, #4c1d95, #831843)",
  shadow:          "0 8px 32px rgba(0,0,0,0.12)",
  shadowCard:      "0 16px 48px rgba(0,0,0,0.15)",
  dateFilter:      "none",
  selectBg:        "rgba(0,0,0,0.18)",
  selectBorder:    "rgba(255,255,255,0.35)",
};

export function ThemeToggle({ isLight, onToggle }) {
  return (
    <button
      onClick={onToggle}
      title={isLight ? "Mudar para tema claro" : "Mudar para tema escuro"}
      style={{
        display: "flex", alignItems: "center", gap: 8,
        background: "rgba(255,255,255,0.12)",
        border: "1px solid rgba(255,255,255,0.2)",
        borderRadius: 8, padding: "7px 14px",
        color: "#fff", fontSize: 12, fontWeight: 600,
        cursor: "pointer", fontFamily: "inherit",
        transition: "background 0.2s",
        backdropFilter: "blur(4px)",
      }}
      onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.2)"}
      onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.12)"}
    >
      {isLight
        ? <><Sun  size={14} /> Claro</>
        : <><Moon size={14} /> Escuro</>
      }
    </button>
  );
}